import { DateTime } from 'luxon';

/**
 * Converts a UTC ISO string to the specified timezone.
 * @param isoString - The UTC ISO string to convert.
 * @param timezone - The target timezone.
 * @returns The converted ISO string in the target timezone, or an empty string if input is null.
 */
export const convertFromUTC = (isoString: string | null, timezone: string): any => {
  if (!isoString) return '';

  //console.log('convertFromUTC: request', isoString, timezone)
  //console.log('convertFromUTC: result', DateTime.fromISO(isoString, { zone: 'utc' }).setZone(timezone).toISO())
  
  return DateTime.fromISO(isoString, { zone: 'utc' }).setZone(timezone).toISO();
};

/**
 * Splits an ISO string into separate date and time components.
 * @param isoString - The ISO string to split.
 * @returns An object containing the date (yyyy-MM-dd) and time (HH:mm) strings.
 *          If the time is midnight (00:00), it returns null for time.
 */
export const splitDateAndTime = (isoString: string | null | undefined): { date: string; time: string | null } => {
  if (!isoString) return { date: '', time: null };
  
  const dateTime = DateTime.fromISO(isoString);
  
  return {
    date: dateTime.toFormat('yyyy-MM-dd'),
    time: dateTime.toFormat('HH:mm')
  };
};

/**
 * Merges separate date and time strings into a single ISO string in the specified timezone.
 * @param date - The date string in 'yyyy-MM-dd' format.
 * @param time - The time string in 'HH:mm' format, or null/undefined if no time is specified.
 * @param timezone - The target timezone for the merged datetime.
 * @returns The merged ISO string in the specified timezone, or an empty string if both date and time are falsy.
 */
export const mergeDateAndTime = (date: string, time: string | null | undefined, timezone: string): string => {
  //console.log('mergeDateAndTime', 'date', date, 'time', time)
  if (!date && !time) {
    console.log('mergeDateAndTime', 'no date or time')
    return '';
  }
  if (!time) {
    console.log('mergeDateAndTime', 'no time')
    return DateTime.fromISO(date).setZone(timezone).toISO() || '';
  }
  console.log('mergeDateAndTime', 'date and time', DateTime.fromFormat(`${date} ${time}`, 'yyyy-MM-dd HH:mm').setZone(timezone).toISO())
  return DateTime.fromFormat(`${date} ${time}`, 'yyyy-MM-dd HH:mm').setZone(timezone).toISO() || '';
};
